






import { computed, defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "GalleryTotalItems",
  props: {
    filesCount: { type: Number, required: true },
    currentItem: { type: Number, required: true },
  },
  setup(props) {
    const text = computed(() => {
      if (props.filesCount === 0) return "";
      return props.currentItem + 1 + "/" + props.filesCount;
    });

    return { text };
  },
});
